import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrenotaPage from './PrenotaPage';
import GestionePage from './GestionePage';
import { PaginaIngresso, PaginaNonDisponibile } from './Componenti';

// Mini-app pubblica degli acquirenti: nessun login, nessun provider di BOP.
// La radice "/" arriva qui solo sui domini prenota.* (vedi instradamento.ts).
export default function PrenotaApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PaginaIngresso />} />
        <Route path="/prenota/a/:token" element={<PrenotaPage modalita="acquirente" />} />
        <Route path="/prenota/gestione/:token" element={<GestionePage />} />
        <Route path="/prenota/:token" element={<PrenotaPage modalita="pagina" />} />
        <Route path="*" element={<PaginaNonDisponibile />} />
      </Routes>
    </BrowserRouter>
  );
}
